module.exports = __webpack_public_path__ + "img/rooted_banner.58b5e819.jpg";